import Avatar from "@common/components/Avatar";
import CloudflareImagesImage from "@common/components/CloudflareImagesImage";
import { ArrowRightIcon } from "@talladega/icons";
import { cleanParagraphTags } from "@talladega/helpers";
import Link from "next/link";
import { BlogHeroHeadingLayout } from "../types/BlogHeroHeadingLayout";

const BlogPageCard = ({
  heroLabel,
  heroSubLabel,
  heroTopSubLabel,
  heroImage,
  button,
  heroAvatar,
}: BlogHeroHeadingLayout) => {
  if (!button) {
    return null;
  }

  return (
    <div className="group aspect-none relative overflow-hidden rounded-lg bg-white pb-4 shadow-elevation-01 transition duration-300 ease-in-out hover:shadow-elevation-03">
      <Link href={button.buttonLink.url}>
        <div className="relative inset-0 h-auto min-w-full">
          <div className="relative h-56 overflow-auto">
            {heroImage && heroImage?.sourceUrl && (
              <CloudflareImagesImage
                src={heroImage?.sourceUrl}
                alt={heroImage.altText}
                fill
                className="z-[2] h-auto w-full object-cover"
              />
            )}
          </div>
        </div>
        <div className="mx-5 mt-2 flex min-h-[5.5rem] flex-col">
          {heroTopSubLabel && (
            <div className="mt-2 w-full items-start justify-start text-left">
              <span className="mt-4 text-sm font-semibold uppercase text-gray-500 lg:mt-8">
                {heroTopSubLabel}
              </span>
            </div>
          )}

          <div className="my-2 flex h-auto flex-col">
            <div className="w-full items-start justify-start text-left">
              <h3
                className="group-hover:text-primary-500"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: cleanParagraphTags(heroLabel),
                }}
              />
            </div>

            <div className="mt-3 w-full text-left">{heroSubLabel}</div>

            {heroAvatar && heroAvatar.avatarImage && heroAvatar.avatarImage && (
              <div className="relative mt-2 flex w-full items-start justify-start text-left">
                <Avatar
                  imageUrl={heroAvatar.avatarImage?.link}
                  size="md"
                  rounded
                />
                <span className="ml-4 mt-2 inline-block items-center justify-center text-center">
                  {heroAvatar.avatarName}
                </span>
              </div>
            )}
          </div>

          <div className="flex flex-grow items-end justify-between pt-1">
            <ArrowRightIcon className="h-6 w-6 text-primary-500" />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BlogPageCard;
